var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, observable, makeObservable } from 'mobx';
import { MenubarPathStep } from './Step/MenubarPathStep';
import { memoize } from '../../../utils/mobx/decorators/memoize';
export class MenubarPath {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get menubar() {
        return this.parent;
    }
    get app() {
        return this.parent.app;
    }
    menubarURI = undefined;
    get menubarLocation() {
        if (!this.menubarURI)
            return this.app.location;
        const location = this.app.model.stream.location[this.menubarURI] || undefined;
        return location;
    }
    get steps() {
        return [
            new MenubarPathStep({ parent: this, depth: 0, depthName: 'instance' }),
            new MenubarPathStep({ parent: this, depth: 1, depthName: 'schooltype' }),
            new MenubarPathStep({ parent: this, depth: 2, depthName: 'form' }),
            new MenubarPathStep({ parent: this, depth: 3, depthName: 'subject' }),
            new MenubarPathStep({ parent: this, depth: 4, depthName: 'categoryOrTopic' }),
            new MenubarPathStep({ parent: this, depth: 5, depthName: 'deepTopic' }),
        ];
    }
    get visibleSteps() {
        return this.steps.slice(1);
    }
    closeAllSteps() {
        this.steps.forEach(s => (s.isNeighbourMenuOpen = false));
        this.app.menubarPath.menubarURI = this.app.location.pathURI;
    }
}
__decorate([
    observable
], MenubarPath.prototype, "menubarURI", void 0);
__decorate([
    computed
], MenubarPath.prototype, "menubarLocation", null);
__decorate([
    memoize
], MenubarPath.prototype, "steps", null);
__decorate([
    action.bound
], MenubarPath.prototype, "closeAllSteps", null);
